export default {"src":"/_next/static/media/VendorManagement.c01beaea.svg","height":80,"width":80,"blurWidth":0,"blurHeight":0};